"use client";

import { AuthProvider } from "@descope/nextjs-sdk";

import { descopeConfig } from "@/config/descope";

export function DescopeProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  return <AuthProvider projectId={descopeConfig.projectId}>{children}</AuthProvider>;
}
